// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorList_container__3GHNI","list":"ErrorList_list__N23Ew"};